import React, { FC } from 'react';
import { IOrder, ProcessStatus } from '../../graphql/types';

export const isCreditBlocked = (status: ProcessStatus): string => {
  switch (status) {
    case 'APPROVED':
      return 'No';
    case 'RELEASED':
      return 'No';
    case 'PARTIALLY_BLOCKED':
      return 'Yes';
    case 'BLOCKED':
      return 'Yes';
    default:
      return 'No';
  }
};

const CreditBlockData: FC<{ order: IOrder }> = ({ order }) => {
  return <div>{isCreditBlocked(order.creditStatus)}</div>;
};

export { CreditBlockData };
